// extracted by mini-css-extract-plugin
module.exports = {"FormControl":"PrimarySlider_FormControl__UdZ9C","Narrow":"PrimarySlider_Narrow__1pPIn","VeryNarrow":"PrimarySlider_VeryNarrow__o4GZj","FullWidth":"PrimarySlider_FullWidth__3EDvm"};